import React from "react";
import { Box, Typography } from "@mui/material";

const CircleProgressLoader = ({ progress = 0, message = "Loading..." }) => {
  const circumference = 2 * Math.PI * 36; // radius = 36

  // Adjust calculation to account for strokeLinecap="round"
  // When progress reaches 100%, we want a complete circle
  const adjustedProgress = progress === 100 ? 99.9 : progress;
  const strokeDashoffset =
    circumference - (adjustedProgress / 100) * circumference;

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <div
        style={{
          color: "white",
          padding: "20px",
          fontSize: "14px",
          textAlign: "center",
          minWidth: "200px",
          backdropFilter: "blur(4px)",
        }}
      >
        <div
          style={{
            fontWeight: 600,
            marginBottom: "16px",
            color: "#1976d2",
          }}
        >
          {message}
        </div>

        {/* SVG Circular Progress */}
        <div
          style={{
            position: "relative",
            width: "80px",
            height: "80px",
            margin: "0 auto 16px",
          }}
        >
          <svg
            width="80"
            height="80"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              transform: "rotate(-90deg)", // Start from top
            }}
          >
            {/* Background circle */}
            <circle
              cx="40"
              cy="40"
              r="36"
              fill="none"
              stroke="rgba(0, 0, 0, 0.08)"
              strokeWidth="4"
            />

            {/* Progress circle */}
            <circle
              cx="40"
              cy="40"
              r="36"
              fill="none"
              stroke="#1976d2"
              strokeWidth="4"
              strokeLinecap={progress === 100 ? "butt" : "round"}
              strokeDasharray={progress === 100 ? "none" : circumference}
              strokeDashoffset={progress === 100 ? 0 : strokeDashoffset}
              style={{
                transition: "stroke-dashoffset 0.3s ease",
              }}
            />
          </svg>

          {/* Progress text in center */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "18px",
              fontWeight: "700",
              color: "#1976d2",
            }}
          >
            {progress.toFixed(0)}%
          </div>
        </div>
      </div>
    </Box>
  );
};

export default CircleProgressLoader;
